import React from "react";
import { formatCurrency } from "../../helpers/estimateTotals";
import { ReportItemRows } from "./ReportItemRows";
import { ReportRule } from "./ReportRule";
import { ReportSubtotalRow } from "./ReportSubtotalRow";

export function ReportSectionPresentation({ title, section, variant = "print" }) {
  if (!section || section.mode === "hidden") return null;

  const isPrint = variant === "print";
  const sectionClassName = isPrint ? "erp-section erp-break-avoid" : undefined;
  const titleClassName = isPrint ? "erp-section-title" : "er-section-title";
  const summaryRowClassName = isPrint ? "erp-totals-row" : "er-summary-row";

  const body = (
    <>
      <ReportRule variant={variant} />
      <h2 className={titleClassName}>{title}</h2>
      {section.mode === "summary" ? (
        <div className={summaryRowClassName}>
          <span>{section.summaryLabel}</span>
          <span>{formatCurrency(section.subtotal)}</span>
        </div>
      ) : (
        <>
          <ReportItemRows rows={section.rows} variant={variant} />
          <ReportSubtotalRow
            label={`${section.summaryLabel} Subtotal`}
            amount={section.subtotal}
            variant={variant}
          />
        </>
      )}
    </>
  );

  if (isPrint) {
    return <section className={sectionClassName}>{body}</section>;
  }

  return body;
}
